import AdditionalFieldsApi from '@/api/additionalFieldsApi'
import Vue from 'vue'
const api = new AdditionalFieldsApi()

export default {
  async setAdditionalFieldsTypes(context, payload) {
    let additionalFieldsTypes = context.getters.getAdditionalFieldsTypes
    if (!additionalFieldsTypes?.length || payload) {
      return await api.getAdditionalFieldTypes()
        .then(response => {
          context.commit('setAdditionalFieldsTypes', response)
          return response
        })
    } else {
      return additionalFieldsTypes
    }
  },
  async addAdditionalFieldСonstructor(context, payload) {
    Vue.prototype.$log( context, payload )
    // return await api.addAdditionalFieldСonstructor(payload)
  }
}